import { render, staticRenderFns } from "./downloadSection.vue?vue&type=template&id=e27cc226&scoped=true&"
import script from "./downloadSection.vue?vue&type=script&lang=js&"
export * from "./downloadSection.vue?vue&type=script&lang=js&"
import style0 from "./downloadSection.vue?vue&type=style&index=0&id=e27cc226&prod&lang=css&"
import style1 from "./downloadSection.vue?vue&type=style&index=1&id=e27cc226&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27cc226",
  null
  
)

export default component.exports